import { Helmet } from 'react-helmet-async';

interface SEOHeadProps {
  title?: string;
  description?: string;
  keywords?: string;
  image?: string;
  url?: string;
  type?: string;
  structuredData?: object;
  // Account/auth/cart pages: keep out of the index, but let link equity flow.
  noindex?: boolean;
}

export const SEOHead: React.FC<SEOHeadProps> = ({
  title = "Koöperasie Veevoer Winkel - Premium Animal Feed & Agricultural Supplies",
  description = "South Africa's premier supplier of quality animal feed, agricultural supplies, and Hardware. Expert advice and competitive prices.",
  keywords = "animal feed, livestock feed, pet supplies, agricultural supplies, South Africa, cattle feed, horse feed, poultry feed, farm supplies",
  image = "https://veevoerwinkel.co.za/share-image-2.jpg",
  url,
  type = "website",
  structuredData,
  noindex = false
}) => {
  return (
    // defer={false} — commit head changes synchronously on mount/update instead of
    // through helmet-async's shared, cancellable requestAnimationFrame. The deferred
    // path could drop the document.title update when an outgoing page's unmount and a
    // fetch-gated page's late <Helmet> mount interleaved across a slow navigation
    // (cold route chunk + Supabase round-trip), leaving the title stuck on the
    // previous page until the next navigation.
    <Helmet defer={false}>
      {/* Primary Meta Tags */}
      <title>{title}</title>
      <meta name="title" content={title} />
      <meta name="description" content={description} />
      <meta name="keywords" content={keywords} />
      {noindex && <meta name="robots" content="noindex, follow" />}
      
      {/* Open Graph / Facebook */}
      <meta property="og:type" content={type} />
      <meta property="og:url" content={url} />
      <meta property="og:title" content={title} />
      <meta property="og:description" content={description} />
      <meta property="og:image" content={image} />
      
      {/* Twitter */}
      <meta property="twitter:card" content="summary_large_image" />
      <meta property="twitter:url" content={url} />
      <meta property="twitter:title" content={title} />
      <meta property="twitter:description" content={description} />
      <meta property="twitter:image" content={image} />
      
      {/* Canonical URL */}
      {url && <link rel="canonical" href={url} />}
      
      {/* Structured Data */}
      {structuredData && (
        <script type="application/ld+json">
          {JSON.stringify(structuredData)}
        </script>
      )}
    </Helmet>
  );
};